import React, { useCallback, useMemo } from "react";
import { createContext } from "react";
import { isBrowserEnv } from "./constants";

const IntlSSRCacheContext = createContext<Record<string, string>>({});

export const ssrIntlCacheMap = new Map<string, string>();

export const IntlSSRCacheProvider = ({
  children,
  currentMessages,
}: {
  children: React.ReactNode;
  currentMessages: Record<string, string>;
}) => {
  return (
    <IntlSSRCacheContext.Provider value={currentMessages}>
      {children}
    </IntlSSRCacheContext.Provider>
  );
};

export const useIntlSSRCache = () => {
  const currentMessages = React.useContext(IntlSSRCacheContext);

  return useCallback(
    (id: string) => {
      ssrIntlCacheMap.set(id, currentMessages[id]);
    },
    [currentMessages]
  );
};

export const parseIntlCacheInCache = () => {
  const cacheIntl = document.querySelector(
    "#__COINTR_INTL_CACHE__"
  ).textContent;
  if (cacheIntl) {
    try {
      const cacheIntlObj = JSON.parse(cacheIntl);
      return cacheIntlObj;
    } catch (error) {
      console.error(error);
      return {};
    }
  }
  return {};
};

export const useIntlCacheInClient = () => {
  return useMemo(() => {
    if (isBrowserEnv) {
      return parseIntlCacheInCache();
    }
    return {};
  }, []);
};
